import { useEffect, useRef } from 'react';

const brands = [
  { name: 'Laminam', country: 'იტალია', category: 'კერამიკული ფილები' },
  { name: 'Antolini', country: 'იტალია', category: 'ბუნებრივი ქვა' },
  { name: 'Ardex', country: 'გერმანია', category: 'საღებავები' },
  { name: 'Hansgrohe', country: 'გერმანია', category: 'სანტექნიკა' },
  { name: 'Tecnopol', country: 'ესპანეთი', category: 'ჰიდროიზოლაცია' },
  { name: 'Dicson', country: 'გერმანია', category: 'იატაკი' },
  { name: 'Marazzi', country: 'იტალია', category: 'კერამიკული ფილები' },
  { name: 'Porcelanosa', country: 'ესპანეთი', category: 'კერამიკული ფილები' },
  { name: 'Axor', country: 'გერმანია', category: 'სანტექნიკა' },
  { name: 'Dornbracht', country: 'გერმანია', category: 'სანტექნიკა' },
];

export default function BrandsShowcase() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-fade-up');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    const els = sectionRef.current?.querySelectorAll('.reveal');
    els?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="bg-[#F5F0E8] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Section Header */}
        <div className="reveal opacity-0 text-center mb-16">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-[#D4A853] mb-4">
            პარტნიორები
          </span>
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-[#1A1A1A] mb-4">
            მსოფლიოს წამყვანი ბრენდები
          </h2>
          <p className="text-[#6B6B6B] text-base md:text-lg max-w-2xl mx-auto">
            ჩვენ ვთანამშრომლობთ მხოლოდ სერთიფიცირებულ და პრემიუმ ბრენდებთან
          </p>
        </div>

        {/* Brands Grid */}
        <div className="reveal opacity-0 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6">
          {brands.map((brand, index) => (
            <div
              key={brand.name}
              className="group bg-white rounded-xl p-6 text-center cursor-pointer transition-all duration-500 hover:bg-[#1A1A1A] hover:shadow-lg"
              style={{ animationDelay: `${index * 0.08}s` }}
            >
              <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-[#F5F0E8] group-hover:bg-[#D4A853]/20 flex items-center justify-center transition-colors duration-500">
                <i className="ri-award-line text-[#D4A853] text-xl"></i>
              </div>
              <h3 className="font-serif text-base font-bold text-[#1A1A1A] group-hover:text-white transition-colors duration-500 mb-1">
                {brand.name}
              </h3>
              <p className="text-xs text-[#6B6B6B] group-hover:text-white/50 transition-colors duration-500">
                {brand.country}
              </p>
              <p className="text-xs text-[#D4A853] mt-1 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                {brand.category}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}